import { useEffect, useState, useContext } from "react";  
import './../../../index.css'
import systemContext from "../../../_context/systemContext";
import { Modal, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { vscService } from "../../../_services/vscService";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import MotivoModal from "../Modales/ModalMotivos";
import '../../../DataTable.css';
import Swal from 'sweetalert2';
import BreadcrumbCatalogos from './BreadcrumbCatalogos';

const Motivos = () => {    
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
    const [showLoader, setShowLoader] = useState(true);
    const [datos, setDatos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState('');    
    // Estados para el modal
    const [showModal, setShowModal] = useState(false);
    const [motivoEdit, setMotivoEdit] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    // Columnas para React Data Table
    const columns = [
        {
            name: 'Clave',
            selector: row => row.clave,
            sortable: true,
            wrap: true,
            width: '100px'
        },
        {
            name: 'Descripción',
            selector: row => row.descripcion,
            sortable: true,
            wrap: true,
            minWidth: '400px', // 👈 más ancha
            grow: 2,
        },
        {
            name: 'Acciones',
            cell: row => (
                <div className="nova-grid-actions">
                    <button 
                        className="nova-btn-action nova-btn-edit"
                        onClick={() => handleEdit(row)}
                        data-tooltip-id="edit-tooltip"
                        data-tooltip-content="Editar motivo"
                    >
                        <FaEdit className="nova-action-icon" />
                    </button>
                    <button 
                        className="nova-btn-action nova-btn-delete"
                        onClick={() => handleDelete(row.id)}
                        data-tooltip-id="delete-tooltip" 
                        data-tooltip-content="Eliminar motivo"
                    >
                        <FaTrash className="nova-action-icon" />
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '120px',
        },
    ];

    // Filtrado de datos
    const filteredItems = datos.filter(item =>
        item.clave?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.descripcion?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.estatus?.toLowerCase().includes(filterText.toLowerCase())
    );

    // Estilos personalizados para la tabla
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: '600',
                minHeight: '50px',
                borderBottom: '2px solid rgba(255, 255, 255, 0.3)',
            },
        },
        headCells: {
            style: {
                paddingLeft: '12px',
                paddingRight: '12px',
                fontSize: '0.85rem',
                fontWeight: '600',
            },
        },
        cells: {
            style: {
                paddingLeft: '10px',
                paddingRight: '10px',
                fontSize: '0.75rem',
                color: 'var(--text-dark)',
            },
        },
        rows: {
            style: {
                fontSize: '0.75rem',
                minHeight: '32px',
                maxHeight: '30px',
                '&:nth-child(even)': {
                    backgroundColor: 'rgba(0, 50, 139, 0.02)',
                },
                '&:hover': {
                    backgroundColor: 'rgba(0, 50, 139, 0.05) !important',
                },
            },
            stripedStyle: {
                backgroundColor: 'rgba(0, 50, 139, 0.02)',
            },
        },
        pagination: {
            style: {
                fontSize: '0.7rem',
                borderTop: '1px solid rgba(0, 50, 139, 0.1)',
                color: 'var(--text-dark)',
            },
        },
    };

    // Opciones de paginación en español
    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    // Componente de búsqueda
    const subHeaderComponent = (
        <div className="nova-table-search">
            <input
                type="text"
                placeholder="Buscar por clave o descripción..."
                className="nova-search-input"
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
            />
            <div className="nova-search-results">
                {filteredItems.length} de {datos.length} registros
            </div>
        </div>
    );

    // Componente cuando no hay datos
    const NoDataComponent = () => (
        <div className="nova-no-data">
            <div className="nova-no-data-icon">📋</div>
            <h3>No se encontraron motivos</h3>
            <p>No hay motivos de venta sin cargo registrados en el sistema.</p>
            {/* <button className="nova-btn-primary" onClick={handleAddNew}>
                + Agregar Primer Motivo
            </button> */}
        </div>
    );

    
    useEffect(() => {
        getMotivos();
    }, []);

    const getMotivos = async () => 
    {
        try {
            setLoading(true);
            const respuesta = await vscService.getMotivosVSC();            
            if (respuesta.status === "OK") {
                const datos = respuesta.content.motivos || respuesta.content.pagos || respuesta.data || [];
                setDatos(datos);                
                // Mensaje de éxito solo si hay datos y es la primera carga
                if (datos.length > 0 && datos.length !== datos.length) {
                    await Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: `${datos.length} motivos cargados.`,
                        showConfirmButton: false,
                        timer: 1200,
                        customClass: {
                            popup: 'nova-swal-popup'
                        }
                    });
                }
            } else {
                throw new Error(respuesta.message || 'Error al cargar motivos');
            }
        } catch (error) {
            console.error('Error en obtener motivos:', error);
            setDatos([]);            
            // Mensaje de error al cargar
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al cargar los motivos.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setLoading(false);
        }
    };

    const handleAddNew = () => {
        setMotivoEdit(null); // Modo creación
        setShowModal(true);
    };

    const handleEdit = (motivo) => {
        setMotivoEdit(motivo); // Modo edición
        setShowModal(true);
    };

    const handleDelete = async (id) => 
    {
        const motivo = datos.find(item => item.id === id);    
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Quieres eliminar el motivo "${motivo?.clave}"? Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                popup: 'nova-swal-popup',
                confirmButton: 'nova-swal-confirm',
                cancelButton: 'nova-swal-cancel'
            }
        });

        if (result.isConfirmed) {
            setLoading(true);
            try {
                // Llamar al método real de eliminación
                const resultado = await vscService.delEliminaMotivo(id);                
                // Verificar si la eliminación fue exitosa
                if (resultado.statusText === "OK" || resultado.success) {
                    // Recargar los datos desde el servidor
                    await getMotivos();                    
                    // Mensaje de éxito
                    await Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Motivo eliminado con éxito.",
                        showConfirmButton: false,
                        timer: 1500,
                        customClass: {
                            popup: 'nova-swal-popup'
                        }
                    });
                } else {
                    throw new Error(resultado.message || 'Error al eliminar');
                }
            } catch (error) {
                console.error('Error al eliminar motivo:', error);
                
                // Mensaje de error
                await Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "Error al eliminar el motivo.",
                    text: error.message || "Por favor, intenta nuevamente.",
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleSaveMotivo = async (formData, id) => 
    {
        setModalLoading(true);
        try {
            // Preparar el JSON según lo que espera tu API
            const motivoData = {
                id: id || 0, // Para insertar id=0, para editar id=existente
                clave: formData.clave,
                descripcion: formData.descripcion
            };
            let resultado;            
            if (id) {
                // Modo edición - usar putEditaMotivo
                resultado = await vscService.putEditaMotivo(motivoData);
            } else {
                // Modo creación - usar postInsertaMotivo
                resultado = await vscService.postInsertaMotivo(motivoData);
            }
            // Verificar si la operación fue exitosa
            if (resultado.status === "OK" || resultado.success) {
                // Recargar los datos desde el servidor
                await getMotivos();                
                setShowModal(false);                
                // Mensaje de éxito
                await Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: id ? "Motivo actualizado con éxito." : "Motivo creado con éxito.",
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } else {
                throw new Error(resultado.message || 'Error en la operación');
            }            
        } catch (error) {
            console.error('Error al guardar motivo:', error);            
            // Mensaje de error
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al guardar el motivo.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setModalLoading(false);
    }
    };

    return (
        <div className="nova-dashboard-balanced">
            <div className="nova-page-header">
                <h3 className="nova-page-title">Motivos de Venta Sin Cargo</h3>
                <div className="nova-header-actions-right">
                    <BreadcrumbCatalogos />
                    <button 
                        className="nova-btn-primary"
                        onClick={handleAddNew}
                    >
                        <FaPlus className="me-2" />
                        Agregar Nuevo Motivo
                    </button>
                </div>
            </div>
            
            {/* Contenedor de la tabla */}
            <div className="nova-data-table-container">
                <DataTable
                    columns={columns}
                    data={filteredItems}
                    customStyles={customStyles}
                    className="nova-react-datatable"
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 25, 50]}
                    paginationComponentOptions={paginationComponentOptions}
                    progressPending={loading}
                    progressComponent={
                        <div className="nova-grid-loading">
                            <Spinner animation="border" role="status" />
                            <p>Cargando motivos...</p>
                        </div>
                    }
                    subHeader
                    subHeaderComponent={subHeaderComponent}
                    noDataComponent={<NoDataComponent />}
                    highlightOnHover
                    striped
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="700px"
                    persistTableHead
                />
            </div>

            {/* Modal para crear/editar */}
            <MotivoModal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                    // NO limpiar motivoEdit aquí, se hace en handleAddNew/handleEdit
                }}
                motivo={motivoEdit}
                onSave={handleSaveMotivo}
                loading={modalLoading}
            />

            {/* Loader Modal */}
            {/* <LoaderModal show={showLoader} /> */}

            {/* Tooltips */}
            <Tooltip id="edit-tooltip" place="top" />
            <Tooltip id="delete-tooltip" place="top" />
        </div>
    );
};

export default Motivos;

// Loader Modal
    // const LoaderModal = ({ show }) => {
    //     return (
    //         <Modal show={show} backdrop="static" keyboard={false} centered>
    //             <Modal.Body className="text-center">
    //                 <Spinner animation="border" role="status" className="mb-3" />
    //                 <h5>Cargando información...</h5>
    //             </Modal.Body>
    //         </Modal>
    //     );
    // };

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setShowLoader(false);
    //     }, 2000);        
    //     return () => clearTimeout(timer);
    // }, []);
